export const isVideo = (item: { contentType: string | null } | null) => {
  if (!item?.contentType) return false;
  return item?.contentType.match(/^video\//);
};
